import React from "react";
import {Progress} from "antd";
import './Overlay.css';

const OverlayProgress = ({percentage, text}) => {
    return (
        <div className="text-center">
            <Progress type="circle" percent={percentage} width={130}/>
            <div>
                <h5>{text}</h5>
            </div>
        </div>
    )
}

export {OverlayProgress};